import React from 'react';
import {useTranslation} from "react-i18next";
import {generate} from "../../../../routing/routes";
import {FormHeading} from "../../../shared/components/Typograhy";
import {ButtonArea, NextButton, OrangeButton} from "../../../shared/components/Buttons";
import { redirect } from "react-router-dom";
import {Advertisement} from "../../../shared/components/Advertisement";

const SubmitConfirmationRightColumn = ({ data }) =>{
    const { t } = useTranslation();
    const shopProduct = data.services[0]?.hike?.shopProduct

    return <>
        <FormHeading title={t('booking.thanks')} />

        <div className="my-10">
            <p className="my-2">{t('booking.reservation_confirmed_information_1')}</p>

            <p className="my-2">{t('booking.reservation_confirmed_information_2')}</p>


        </div>

        <ButtonArea>
            <NextButton
                classname="ml-auto"
                href={generate('customer_reservation', { reference: data.reference })}
            >
                {t('booking.follow_my_request')}
            </NextButton>
        </ButtonArea>

        {shopProduct && <Advertisement product={shopProduct} />}
    </>}
;

export default SubmitConfirmationRightColumn;
